// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Base / Layout ===== */
.setting-wrap {
    background: #fff;
}

.setting-viewport {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    min-height: 100dvh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    background: #fff;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    overflow: hidden;
}

/* ===== Header ===== */
.setting-header {
    flex-shrink: 0;
    padding: 18px 14px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.setting-logo {
    width: 110px;
    height: auto;
    object-fit: contain;
    cursor: pointer;
}

.setting-logout-icon {
    position: absolute;
    right: 18px;
    top: 18px;
    border: none;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
    font-size: 18px;
}

/* ===== Main ===== */
.setting-main {
    padding-bottom: 90px;
    display: flex;
    flex-direction: column;
    background: #fff;
}

.profile-main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
}

.profile-scroll {
    flex-shrink: 0;
    padding: 10px 20px 5px;
}

.profile-scroll-fields {
    flex: 1 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 20px;
    min-height: 0;
}

/* ===== Profile Card ===== */
.setting-card {
    display: grid;
    grid-template-columns: 1fr 20px;
    gap: 12px;
    align-items: center;
    background: #E9F1FB;
    border-radius: 18px;
    border: 1px solid #1C6DD0;
    padding: 14px;
    /* 입체감: 상자 떠 보이게 */
    box-shadow:
        0px -1px 2px rgba(16, 24, 40, .06), 0 2px 4px rgba(16, 24, 40, .10);
    cursor: pointer;
    margin: 10px 15px;
}

.setting-card:active {
    transform: translateY(1px);
}

.setting-avatar {
    width: 56px;
    height: 56px;
    border-radius: 999px;
    background: linear-gradient(135deg, #f7f8fa, #eef2f7);
    box-shadow: inset 0 0 0 2px #e6ebf2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.setting-info {
    display: grid;
    gap: 6px;
    min-width: 0;
}

.setting-row {
    display: grid;
    grid-template-columns: 45px 1fr;
    gap: 8px;
    align-items: flex-start;
}

.setting-key {
    font-size: 15px;
    color: #6b7280;
}

.setting-value {
    font-size: 15px;
    font-weight: 500;
    color: #111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.setting-chevron {
    font-size: 14px;
    padding: 0 4px;
}

/* ===== Section List ===== */
.setting-list {
    background: #fff;
    /* border-radius: 16px; */
    overflow: hidden;
    /* box-shadow:
        0 1px 2px rgba(16, 24, 40, .06),
        0 6px 16px rgba(16, 24, 40, .06); */
}

/* ===== 새 프로필 페이지 ===== */
.profile-avatar-wrap {
    display: flex;
    justify-content: center;
    margin: 0px 0 8px;
}

.profile-avatar-img {
    width: 110px;
    height: 110px;
    border-radius: 999px;
    object-fit: cover;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
}

.profile-avatar-placeholder {
    width: 110px;
    height: 110px;
    border-radius: 999px;
    background: linear-gradient(135deg, #f7f8fa, #eef2f7);
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
}

.profile-avatar-upload-btn {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(50%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #2563eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border: 3px solid #fff;
}

.profile-avatar-upload-btn:hover {
    /* transform: scale(1.05); */
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); */
}

/* 프로필 페이지 스켈레톤 UI */
.profile-avatar-skeleton {
    width: 110px;
    height: 110px;
    border-radius: 999px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
}

.profile-name-skeleton {
    /* .profile-name-main과 동일한 스타일 */
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin: 10px auto 0;
    /* 실제 이름의 평균적인 너비를 시뮬레이션 */
    width: 120px;
    height: 1.2em; /* line-height 고려 */
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 4px;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.profile-avatar-upload-btn:active {
    /* transform: scale(0.95); */
}

.profile-summary {
    text-align: center;
}

.profile-name-main {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
}

.profile-email-main {
    font-size: 13px;
    color: #6b7280;
}

.profile-section {
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
}

.profile-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f3f4f6;
}

/* 수정 모드에서의 profile-row padding */
.profile-row.editing {
    padding: 5px 0;
}

.profile-row-memo {
    align-items: flex-start;
}

.profile-label {
    flex: 0 0 95px;
    font-size: 18px;
    color: #6b7280;
}

.profile-value {
    flex: 1 1;
    text-align: right;
    font-size: 18px;
    color: #111827;
    word-break: break-word;
}

.profile-value-memo {
    white-space: pre-wrap;
}

.profile-input,
.profile-textarea {
    flex: 1 1;
    font-size: 18px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 6px 10px;
    outline: none;
    box-sizing: border-box;
}

.profile-input:focus,
.profile-textarea:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
}

.profile-textarea {
    resize: vertical;
    min-height: 70px;
}

.profile-actions {
    flex-shrink: 0;
    padding: 5px 20px 10px;
    display: flex;
    gap: 10px;
    background: #fff;
}

.profile-edit-btn,
.profile-save-btn,
.profile-cancel-btn {
    flex: 1 1;
    height: 52px;
    border-radius: 999px;
    border: none;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
}

.profile-edit-btn {
    background: #2563eb;
    color: #fff;
}

.profile-edit-btn.disabled,
.profile-edit-btn:disabled {
    background: #9ca3af;
    color: #fff;
    cursor: not-allowed;
    opacity: 0.7;
}

.profile-save-btn {
    background: #2563eb;
    color: #fff;
}

.profile-cancel-btn {
    background: #e5e7eb;
    color: #374151;
}

.setting-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 15px;
    color: #111;
    border-bottom: 1px solid #f0f2f5;
    font-weight: bold;
}

/* ===== Modal (Edit Profile) ===== */
.setting-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 16px;
}

.setting-modal {
    width: min(680px, 100%);
    max-height: 90vh;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 16px 44px rgba(0, 0, 0, .22);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: settingPop .16s ease-out;
}

@keyframes settingPop {
    from {
        transform: translateY(8px) scale(.98);
        opacity: .0;
    }

    to {
        transform: none;
        opacity: 1;
    }
}

.setting-modal-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-bottom: 1px solid #eee;
    background: #fff;
}

.setting-close {
    border: none;
    background: #111;
    color: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    cursor: pointer;
}

.setting-modal-body {
    padding: 14px;
    display: grid;
    gap: 5px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

.setting-label {
    font-size: 13px;
    color: #6b7280;
}

.setting-input {
    height: 40px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0 12px;
    font-size: 15px;
    outline: none;
    background: #fff;
}

.setting-input:focus {
    border-color: #89a9ff;
    box-shadow: 0 0 0 3px rgba(47, 134, 255, .15);
}

.setting-textarea {
    height: 90px;
    padding: 10px 12px;
    resize: vertical;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #fff;
}

/* Modal Actions */
.setting-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 12px 14px 16px;
    border-top: 1px solid #f1f3f5;
    background: #fff;
}

.setting-btn {
    min-width: 96px;
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 999px;
    background: #ff6a63;
    color: #fff;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 6px 14px rgba(255, 106, 99, .28);
}

.setting-btn.outline {
    background: #fff;
    color: #111;
    border: 1px solid #e5e7eb;
    box-shadow: none;
    font-weight: 700;
}

/* ===== Utilities / Safe Area ===== */
@supports (padding: max(0px)) {
    .setting-header {
        padding-top: max(18px, env(safe-area-inset-top));
    }
}

/* 프로필 수정 모달 내 주소 검색 UI 보조 */
.setting-fieldset {
    display: grid;
    gap: 5px;
    margin-bottom: 6px;
}

.setting-input-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
}

.setting-btn.small {
    min-width: 72px;
    height: 40px;
    padding: 0 12px;
    border-radius: 10px;
    background: #2f86ff;
    color: #fff;
    font-weight: 700;
    box-shadow: none;
}

/* 주소 검색 레이어는 기존 모달 스타일 재사용 + 높이 보정 */
.setting-addr-body {
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/setting.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gGAAgG;IAChG,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB;2EACuE;IACvE,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,qDAAqD;IACrD,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB;;2CAEuC;AAC3C;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,qDAAqD;IACrD,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,+CAA+C;AACnD;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,yEAAyE;IACzE,0BAA0B;IAC1B,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,aAAa,EAAE,mBAAmB;IAClC,yEAAyE;IACzE,0BAA0B;IAC1B,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gCAAgC;AACpC;;AAEA,iCAAiC;AACjC;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,SAAO;IACP,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;IAGI,SAAO;IACP,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI;QACI,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,QAAQ;IACR,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC","sourcesContent":["/* ===== Base / Layout ===== */\r\n.setting-wrap {\r\n    background: #fff;\r\n}\r\n\r\n.setting-viewport {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    min-height: 100dvh;\r\n    height: 100dvh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: #fff;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    overflow: hidden;\r\n}\r\n\r\n/* ===== Header ===== */\r\n.setting-header {\r\n    flex-shrink: 0;\r\n    padding: 18px 14px 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.setting-logo {\r\n    width: 110px;\r\n    height: auto;\r\n    object-fit: contain;\r\n    cursor: pointer;\r\n}\r\n\r\n.setting-logout-icon {\r\n    position: absolute;\r\n    right: 18px;\r\n    top: 18px;\r\n    border: none;\r\n    background: transparent;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n}\r\n\r\n/* ===== Main ===== */\r\n.setting-main {\r\n    padding-bottom: 90px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: #fff;\r\n}\r\n\r\n.profile-main {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    min-height: 0;\r\n}\r\n\r\n.profile-scroll {\r\n    flex-shrink: 0;\r\n    padding: 10px 20px 5px;\r\n}\r\n\r\n.profile-scroll-fields {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    padding: 0 20px;\r\n    min-height: 0;\r\n}\r\n\r\n/* ===== Profile Card ===== */\r\n.setting-card {\r\n    display: grid;\r\n    grid-template-columns: 1fr 20px;\r\n    gap: 12px;\r\n    align-items: center;\r\n    background: #E9F1FB;\r\n    border-radius: 18px;\r\n    border: 1px solid #1C6DD0;\r\n    padding: 14px;\r\n    /* 입체감: 상자 떠 보이게 */\r\n    box-shadow:\r\n        0px -1px 2px rgba(16, 24, 40, .06), 0 2px 4px rgba(16, 24, 40, .10);\r\n    cursor: pointer;\r\n    margin: 10px 15px;\r\n}\r\n\r\n.setting-card:active {\r\n    transform: translateY(1px);\r\n}\r\n\r\n.setting-avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n    border-radius: 999px;\r\n    background: linear-gradient(135deg, #f7f8fa, #eef2f7);\r\n    box-shadow: inset 0 0 0 2px #e6ebf2;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.setting-info {\r\n    display: grid;\r\n    gap: 6px;\r\n    min-width: 0;\r\n}\r\n\r\n.setting-row {\r\n    display: grid;\r\n    grid-template-columns: 45px 1fr;\r\n    gap: 8px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.setting-key {\r\n    font-size: 15px;\r\n    color: #6b7280;\r\n}\r\n\r\n.setting-value {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    color: #111;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.setting-chevron {\r\n    font-size: 14px;\r\n    padding: 0 4px;\r\n}\r\n\r\n/* ===== Section List ===== */\r\n.setting-list {\r\n    background: #fff;\r\n    /* border-radius: 16px; */\r\n    overflow: hidden;\r\n    /* box-shadow:\r\n        0 1px 2px rgba(16, 24, 40, .06),\r\n        0 6px 16px rgba(16, 24, 40, .06); */\r\n}\r\n\r\n/* ===== 새 프로필 페이지 ===== */\r\n.profile-avatar-wrap {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 0px 0 8px;\r\n}\r\n\r\n.profile-avatar-img {\r\n    width: 110px;\r\n    height: 110px;\r\n    border-radius: 999px;\r\n    object-fit: cover;\r\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);\r\n}\r\n\r\n.profile-avatar-placeholder {\r\n    width: 110px;\r\n    height: 110px;\r\n    border-radius: 999px;\r\n    background: linear-gradient(135deg, #f7f8fa, #eef2f7);\r\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #9ca3af;\r\n}\r\n\r\n.profile-avatar-upload-btn {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform: translateX(50%);\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background-color: #2563eb;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n    border: 3px solid #fff;\r\n}\r\n\r\n.profile-avatar-upload-btn:hover {\r\n    /* transform: scale(1.05); */\r\n    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); */\r\n}\r\n\r\n/* 프로필 페이지 스켈레톤 UI */\r\n.profile-avatar-skeleton {\r\n    width: 110px;\r\n    height: 110px;\r\n    border-radius: 999px;\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s ease-in-out infinite;\r\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);\r\n}\r\n\r\n.profile-name-skeleton {\r\n    /* .profile-name-main과 동일한 스타일 */\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    text-align: center;\r\n    margin: 10px auto 0;\r\n    /* 실제 이름의 평균적인 너비를 시뮬레이션 */\r\n    width: 120px;\r\n    height: 1.2em; /* line-height 고려 */\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s ease-in-out infinite;\r\n    border-radius: 4px;\r\n}\r\n\r\n@keyframes skeleton-loading {\r\n    0% {\r\n        background-position: 200% 0;\r\n    }\r\n    100% {\r\n        background-position: -200% 0;\r\n    }\r\n}\r\n\r\n.profile-avatar-upload-btn:active {\r\n    /* transform: scale(0.95); */\r\n}\r\n\r\n.profile-summary {\r\n    text-align: center;\r\n}\r\n\r\n.profile-name-main {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    color: #111827;\r\n}\r\n\r\n.profile-email-main {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n}\r\n\r\n.profile-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* gap: 10px; */\r\n}\r\n\r\n.profile-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    padding: 12px 0;\r\n    border-bottom: 1px solid #f3f4f6;\r\n}\r\n\r\n/* 수정 모드에서의 profile-row padding */\r\n.profile-row.editing {\r\n    padding: 5px 0;\r\n}\r\n\r\n.profile-row-memo {\r\n    align-items: flex-start;\r\n}\r\n\r\n.profile-label {\r\n    flex: 0 0 95px;\r\n    font-size: 18px;\r\n    color: #6b7280;\r\n}\r\n\r\n.profile-value {\r\n    flex: 1;\r\n    text-align: right;\r\n    font-size: 18px;\r\n    color: #111827;\r\n    word-break: break-word;\r\n}\r\n\r\n.profile-value-memo {\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.profile-input,\r\n.profile-textarea {\r\n    flex: 1;\r\n    font-size: 18px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 10px;\r\n    padding: 6px 10px;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.profile-input:focus,\r\n.profile-textarea:focus {\r\n    border-color: #2563eb;\r\n    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);\r\n}\r\n\r\n.profile-textarea {\r\n    resize: vertical;\r\n    min-height: 70px;\r\n}\r\n\r\n.profile-actions {\r\n    flex-shrink: 0;\r\n    padding: 5px 20px 10px;\r\n    display: flex;\r\n    gap: 10px;\r\n    background: #fff;\r\n}\r\n\r\n.profile-edit-btn,\r\n.profile-save-btn,\r\n.profile-cancel-btn {\r\n    flex: 1;\r\n    height: 52px;\r\n    border-radius: 999px;\r\n    border: none;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n\r\n.profile-edit-btn {\r\n    background: #2563eb;\r\n    color: #fff;\r\n}\r\n\r\n.profile-edit-btn.disabled,\r\n.profile-edit-btn:disabled {\r\n    background: #9ca3af;\r\n    color: #fff;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n}\r\n\r\n.profile-save-btn {\r\n    background: #2563eb;\r\n    color: #fff;\r\n}\r\n\r\n.profile-cancel-btn {\r\n    background: #e5e7eb;\r\n    color: #374151;\r\n}\r\n\r\n.setting-item {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 14px 20px;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    color: #111;\r\n    border-bottom: 1px solid #f0f2f5;\r\n    font-weight: bold;\r\n}\r\n\r\n/* ===== Modal (Edit Profile) ===== */\r\n.setting-modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, .45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9999;\r\n    padding: 16px;\r\n}\r\n\r\n.setting-modal {\r\n    width: min(680px, 100%);\r\n    max-height: 90vh;\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    box-shadow: 0 16px 44px rgba(0, 0, 0, .22);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    animation: settingPop .16s ease-out;\r\n}\r\n\r\n@keyframes settingPop {\r\n    from {\r\n        transform: translateY(8px) scale(.98);\r\n        opacity: .0;\r\n    }\r\n\r\n    to {\r\n        transform: none;\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.setting-modal-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 12px 14px;\r\n    border-bottom: 1px solid #eee;\r\n    background: #fff;\r\n}\r\n\r\n.setting-close {\r\n    border: none;\r\n    background: #111;\r\n    color: #fff;\r\n    border-radius: 8px;\r\n    padding: 6px 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.setting-modal-body {\r\n    padding: 14px;\r\n    display: grid;\r\n    gap: 5px;\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.setting-label {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n}\r\n\r\n.setting-input {\r\n    height: 40px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 10px;\r\n    padding: 0 12px;\r\n    font-size: 15px;\r\n    outline: none;\r\n    background: #fff;\r\n}\r\n\r\n.setting-input:focus {\r\n    border-color: #89a9ff;\r\n    box-shadow: 0 0 0 3px rgba(47, 134, 255, .15);\r\n}\r\n\r\n.setting-textarea {\r\n    height: 90px;\r\n    padding: 10px 12px;\r\n    resize: vertical;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 10px;\r\n    background: #fff;\r\n}\r\n\r\n/* Modal Actions */\r\n.setting-modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    padding: 12px 14px 16px;\r\n    border-top: 1px solid #f1f3f5;\r\n    background: #fff;\r\n}\r\n\r\n.setting-btn {\r\n    min-width: 96px;\r\n    height: 40px;\r\n    padding: 0 16px;\r\n    border: none;\r\n    border-radius: 999px;\r\n    background: #ff6a63;\r\n    color: #fff;\r\n    font-weight: 800;\r\n    cursor: pointer;\r\n    box-shadow: 0 6px 14px rgba(255, 106, 99, .28);\r\n}\r\n\r\n.setting-btn.outline {\r\n    background: #fff;\r\n    color: #111;\r\n    border: 1px solid #e5e7eb;\r\n    box-shadow: none;\r\n    font-weight: 700;\r\n}\r\n\r\n/* ===== Utilities / Safe Area ===== */\r\n@supports (padding: max(0px)) {\r\n    .setting-header {\r\n        padding-top: max(18px, env(safe-area-inset-top));\r\n    }\r\n}\r\n\r\n/* 프로필 수정 모달 내 주소 검색 UI 보조 */\r\n.setting-fieldset {\r\n    display: grid;\r\n    gap: 5px;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.setting-input-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    gap: 8px;\r\n}\r\n\r\n.setting-btn.small {\r\n    min-width: 72px;\r\n    height: 40px;\r\n    padding: 0 12px;\r\n    border-radius: 10px;\r\n    background: #2f86ff;\r\n    color: #fff;\r\n    font-weight: 700;\r\n    box-shadow: none;\r\n}\r\n\r\n/* 주소 검색 레이어는 기존 모달 스타일 재사용 + 높이 보정 */\r\n.setting-addr-body {\r\n    flex: 1 1 auto;\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    overscroll-behavior: contain;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
